import { ICartItem } from 'interfaces/cart.interface';
import { ProductStatusEnum } from 'interfaces/product.interface';
import router from 'next/router';
import { useMemo, useState } from 'react';

type CartItemProps = {
  item: ICartItem;
};

export default function useCartItem({ item }: CartItemProps) {
  // init is remove cart item
  const [isRemoveCartItem, setIsRemoveCartItem] = useState<boolean>(false);

  // get attributes name from item
  const attributesNames: string[] = useMemo(() => {
    if (
      item.product &&
      item.attributeOptions &&
      item.attributeOptions.length > 0 &&
      item.product.attributes
    ) {
      // get attribute by attributesOptions.productAttributeId
      const attributes = item.product.attributes.filter((attribute) => {
        const _attribute = item.attributeOptions!.some(
          (attributeOption) =>
            attributeOption.productAttributeId === attribute.id
        );

        return _attribute;
      });

      // log attributes
      console.log('attributes', attributes);

      // assign attributeOption to attribute
      const attributesWithOptions = attributes.map((attribute) => {
        const attributeOptions = item.attributeOptions!.filter(
          (attributeOption) =>
            attributeOption.productAttributeId === attribute.id
        );

        return {
          ...attribute,
          attributeOptions,
        };
      });

      console.log('attributesWithOptions', attributesWithOptions);

      // get attribute name
      const attributeNames = attributesWithOptions.map((attribute) => {
        if (router.locale === 'en') {
          return `${attribute.name_en} : ${attribute.attributeOptions[0].name_en}`;
        } else {
          if (attribute.name_th) {
            return `${attribute.name_th} : ${attribute.attributeOptions[0].name_th}`;
          } else {
            return `${attribute.name_en} : ${attribute.attributeOptions[0].name_en}`;
          }
        }
      });

      return attributeNames;
    }

    return [];
  }, [item]);

  // get attributes name from item short
  const attributesNamesShort: string[] = useMemo(() => {
    if (
      item.product &&
      item.attributeOptions &&
      item.attributeOptions.length > 0 &&
      item.product.attributes
    ) {
      // get attribute by attributesOptions.productAttributeId
      const attributes = item.product.attributes.filter((attribute) => {
        const _attribute = item.attributeOptions!.some(
          (attributeOption) =>
            attributeOption.productAttributeId === attribute.id
        );

        return _attribute;
      });

      // log attributes
      console.log('attributes', attributes);

      // assign attributeOption to attribute
      const attributesWithOptions = attributes.map((attribute) => {
        const attributeOptions = item.attributeOptions!.filter(
          (attributeOption) =>
            attributeOption.productAttributeId === attribute.id
        );

        return {
          ...attribute,
          attributeOptions,
        };
      });

      console.log('attributesWithOptions', attributesWithOptions);

      // get attribute name
      const attributeNames = attributesWithOptions.map((attribute) => {
        if (router.locale === 'en') {
          return `${attribute.attributeOptions[0].name_en}`;
        } else {
          if (attribute.name_th) {
            return `${attribute.attributeOptions[0].name_th}`;
          } else {
            return `${attribute.attributeOptions[0].name_en}`;
          }
        }
      });

      // log attributeNames
      console.log('attributeNames', attributeNames);

      return attributeNames;
    }

    return [];
  }, [item]);

  // get variation from item
  const variation = useMemo(() => {
    if (
      item.product &&
      item.attributeOptions &&
      item.attributeOptions.length &&
      item.product.variations
    ) {
      const variation = item.product.variations.find((variation) => {
        const _variation = variation.attributeOptions?.every(
          (attributeOption) => {
            const _attributeOption = item.attributeOptions!.some(
              (itemAttributeOption) =>
                itemAttributeOption.id === attributeOption.id
            );

            return _attributeOption;
          }
        );

        return _variation;
      });

      return variation;
    }

    return null;
  }, [item]);

  const featuresImage: string = useMemo(() => {
    if (variation) {
      if (variation.gallery && variation.gallery.length > 0) {
        return `${process.env.NEXT_PUBLIC_FILE_URL}/${variation.gallery[0]?.name}`;
      }
    } else {
      if (item.product) {
        if (item.product.featuredImage) {
          return `${process.env.NEXT_PUBLIC_FILE_URL}/${item.product.featuredImage.name}`;
        }
      }
    }

    return '/image-icon/empty-image.png';
  }, [item.product]);

  // get sku from product or variation
  const sku = useMemo(() => {
    if (variation) {
      return variation.sku;
    } else {
      return item.product?.sku;
    }
  }, [item, variation]);

  const isAvailableForPurchase = useMemo(() => {
    if (item.product.status !== ProductStatusEnum.PUBLISHED) {
      return false;
    }

    if (variation) {
      return (
        variation.stockQuantity &&
        variation.stockQuantity > 0 &&
        variation.visibility &&
        variation.claimedPrice &&
        variation.claimedPrice > 0 &&
        variation.weight &&
        variation.weight > 0
      );
    } else {
      return (
        item.product.stockQuantity &&
        item.product.stockQuantity > 0 &&
        item.product.weight &&
        item.product.weight > 0
      );
    }
  }, [item, variation]);

  return {
    isRemoveCartItem,
    setIsRemoveCartItem,
    attributesNames,
    attributesNamesShort,
    featuresImage,
    variation,
    sku,
    isAvailableForPurchase,
  };
}
